import React from 'react'
import EventsOverview from '../../../react4xp/components/EventsOverview'

function EventsOverviewPart({ title, intro, futureEvents, pastEventsEndpoint, strings }) {
    return (
        <EventsOverview title={title} intro={`<p>${intro}</p>`} futureEvents={futureEvents} endpoint={pastEventsEndpoint} linkText="Visit website" strings={strings} />
    )
}

export default (props) => <EventsOverviewPart {...props} />
